import { z } from 'zod';

export const TeamUserUpdateSchema = z.object({
    is_owner: z.boolean(),
});
